import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import {AbstractRepositoryV2} from "../../../../../../core/service/v2/abstractRepositoryV2";
import {InsoleElementDefinitionModel} from "../../../api/model/insoleElementDefinition.model";

@Injectable({
    providedIn: 'root'
})
export class InsoleElementDefinitionRepository extends AbstractRepositoryV2<InsoleElementDefinitionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('InsoleElementDefinition', serviceElementsFactory, injector);
    }
}
